module.exports = __webpack_public_path__ + "static/WAHousingLogo-b9bfd04b1584fe66681e2a96829f121c.svg";